import React from "react";
import { Route } from "react-router-dom";

import SentryRoutes from "../SentryRoutes";
import NotFound from "../components/Pages/NotFound";
import AuthPageGuard from "./AuthPageGuard";
import ProfessionalRouteGuard from "./ProfessionalRouteGuard";
import {
  customerRouteConfig,
  professionalRouteConfig,
  recruiterRouteConfig,
} from "./routeConfig";
import RecruiterRouteGuard from "./RecruiterRouteGuard";

const AUTH_PAGE_PATHS = new Set(["/login", "/signup", "/signup/details"]);

const CustomerRoutes = () => {
  return (
    <SentryRoutes>
      {customerRouteConfig.map(({ path, component: Component }) => (
        <Route
          key={path}
          path={path}
          element={
            AUTH_PAGE_PATHS.has(path) ? (
              <AuthPageGuard>
                <Component />
              </AuthPageGuard>
            ) : (
              <Component />
            )
          }
        />
      ))}

      {professionalRouteConfig.map(({ path }) => (
        <Route
          key={`restricted-${path}`}
          path={path}
          element={<ProfessionalRouteGuard />}
        />
      ))}

      {recruiterRouteConfig.map(({ path }) => (
        <Route
          key={`recruiter-${path}`}
          path={path}
          element={
            <RecruiterRouteGuard />
          }
        />
      ))}

      {/* Keep last: a catch-all registered earlier would shadow the real routes. */}
      <Route path="*" element={<NotFound />} />
    </SentryRoutes>
  );
};

export default CustomerRoutes;
